import Component from "@glimmer/component";
import { action } from "@ember/object";
import { trackedObject } from "@ember/reactive/collections";
import { service } from "@ember/service";
import DButton from "discourse/ui-kit/d-button";
import DModal from "discourse/ui-kit/d-modal";
import DModalCancel from "discourse/ui-kit/d-modal-cancel";
import { i18n } from "discourse-i18n";
import AssignUserForm from "../assign-user-form";

export default class AssignUser extends Component {
  @service taskActions;

  model = trackedObject(this.args.model);

  // `submit` property will be mutated by the `AssignUserForm` component
  formApi = {
    submit() {},
  };

  get title() {
    let i18nSuffix;

    switch (this.model.targetType) {
      case "Post":
        i18nSuffix = "_post_modal";
        break;
      case "Topic":
        i18nSuffix = "_modal";
        break;
    }

    return i18n(
      `discourse_assign.assign${i18nSuffix}.${
        this.model.reassign ? "reassign_title" : "title"
      }`
    );
  }

  @action
  async onSubmit() {
    this.args.closeModal();
    await this.taskActions.assign(this.model);
  }

  <template>
    <DModal class="assign" @closeModal={{@closeModal}} @title={{this.title}}>
      <:body>
        <AssignUserForm
          @formApi={{this.formApi}}
          @model={{this.model}}
          @onSubmit={{this.onSubmit}}
        />
      </:body>

      <:footer>
        <DButton
          class="btn-primary"
          @action={{this.formApi.submit}}
          @label={{if
            this.model.reassign
            "discourse_assign.reassign.title"
            "discourse_assign.assign_modal.assign"
          }}
        />

        <DModalCancel @close={{@closeModal}} />
      </:footer>
    </DModal>
  </template>
}
